import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function Warranty(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>
                    <th>{trans('tables.type')}</th>
                    <th>{trans('tables.contractor')}</th>
                    <th>{trans('tables.category')}</th>
                    <th>{trans('tables.brand')}</th>
                    <th>{trans('tables.model')}</th>
                    <th>{trans('tables.activated_at')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>
                            <td>{h.subject?.type?.name ?? '-'}</td>
                            <td>{h.subject?.contractor?.name ?? '-'}</td>
                            <td>{h.subject?.appliancecategory?.name ?? '-'}</td>
                            <td>{h.subject?.appliancebrand?.name ?? '-'}</td>
                            <td>{h.subject?.appliancemodel?.name ?? '-'}</td>
                            <td>{h.subject?.activated_at ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default Warranty;